import { render, staticRenderFns } from "./RightPreview.vue?vue&type=template&id=37824fad&scoped=true"
import script from "./RightPreview.vue?vue&type=script&lang=js"
export * from "./RightPreview.vue?vue&type=script&lang=js"
import style0 from "./RightPreview.vue?vue&type=style&index=0&id=37824fad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37824fad",
  null
  
)

export default component.exports